export default __webpack_public_path__ + "static/media/93a66db68055dd4682f323ada06fd9b91581619595907.3c8ff8fd.webp";